import State from 'webutils/services/state'

export default [
    new State("EN", "England"),
    new State("NI", "Northern Ireland"),
    new State("SC", "Scotland"),
    new State("WA", "Wales")
];